
import { Link } from "react-router-dom";

const LOGO_URL = "/lovable-uploads/adbefe14-3b0b-4fb7-9d68-80ff26cf5191.png";

export function NavbarLogo() {
  return (
    <Link to="/" className="flex items-center">
      <img
        src={LOGO_URL}
        alt="Dr.Cash Logo"
        className="h-10 md:h-12"
      />
    </Link>
  );
}
